import React from "react";
import ProgrammeDetail from "../../ProgrammeDetail";
import facultyData from "../UG/facultyData/basicScienceFacultyData";

export const programme = {
  id: "physics",
  name: "Physics Research Centre",
  short: "Physics Research Centre",
  programmeType: "research",
  programmeLabel: "Research Centre",
  duration: "Ph.D. / M.Sc. (Engg.) by Research",
  established: "As per VTU recognition",
  hodId: "f-mallikarjun-k-patil",
  facultyData,
  facultyDeptId: "bsh",
  hideFacultySection: true,
  hideSharedClubs: true,

  description:
    "The department is recognized as “Research Center” in the year 2015 and offers Ph.D./ M.Sc.(Engg.) program by research, which is affiliated to Visvesvaraya Technological University, Belagavi, vide VTU letter no. VTU/Aca-Res-Cen./2015-16/6502(f) dated 21-10-2015.The faculty members are actively involved in research activities. Major areas of research are vibrational spectroscopy, DFT calculations, Semiconductors, Nano-materials, Condensed matter physics, Laser spectroscopy and Transport properties of Dilute magnetic semiconductors and thin films.Faculty members have published 15 research papers in their respective fields in international journals and have presented a good number of papers in national / international conferences and seminars.Applications are invited for registration to Full time / Part time Ph.D. Programs in Physics as per prevailing regulations of Visvesvaraya Technological University, Belgaum. Eligibility Criteria for enrolment to Ph.D. is as per VTU rules available on the link:",

  image: "/Academics/physics.jpg",

  labs: [
    "Physics Lab",
    "Materials Characterisation Lab",
    "Spectroscopy Facilities",
    "Research Workspaces",
  ],

  dashboard: [
    ["Recognition", "VTU"],
    ["Research Areas", "05"],
    ["Research Supervisors", "03"],
    ["Research Scholars", "To be updated"],
  ],

  quickFacts: [
    ["Established", "As per VTU recognition"],
    ["Programme", "Ph.D. / M.Sc. (Engg.) by Research"],
    ["Research Supervisors", "03"],
    ["Research Scholars", "To be updated"],
    ["Research Areas", "Materials Science, Spectroscopy, Nanomaterials, Condensed Matter Physics"],
    ["Affiliation", "VTU, Belagavi"],
  ],

  academicOverview: [
    {
      title: "Research Centre Overview",
      text:
        "The Physics Research Centre provides a focused environment for scholarly work in materials, spectroscopy, nanomaterials, and condensed matter physics through faculty mentoring and research-oriented academic activity.",
    },
    {
      title: "Research Facilities",
      text:
        "The centre uses physics laboratories, materials characterisation support, spectroscopy facilities, computational resources, and research workspaces for experimentation and analysis.",
    },
    {
      title: "Research Culture",
      text:
        "Faculty members contribute through publications, conference participation, invited lectures, faculty development programmes, and interdisciplinary research engagement.",
    },
  ],

  curriculumSupport: [
    "Ph.D. and M.Sc. (Engineering) by Research guidance",
    "Materials and spectroscopy experimentation",
    "Research methodology and literature review support",
    "Data analysis and technical documentation",
    "Conference and journal publication support",
    "Interdisciplinary research mentoring",
  ],

  researchAreas: [
    "Materials Science",
    "Spectroscopy",
    "Nanomaterials",
    "Condensed Matter Physics",
    "Semiconductor Nano-structures",
  ],

  infrastructureTables: [
    {
      columns: [
        "Name of the Research Lab",
        "No.of PCs available",
        "List of Software",
        "Amount Spent Till Date",
      ],
      rows: [["Physics", "02", "Open Source Software", "50000.0"]],
    },
    {
      columns: ["Sl. No.", "Research Laboratory", "Carpet Area (Sq.mt)", "Major Equipments"],
      rows: [["1.", "Physics", "50", "Ultrasonic Interferometer Electrical Resistivity by Four-Probe Method."]],
    },
  ],

  achievements: [
    "Supports research publications in physics and materials science.",
    "Faculty members actively contribute to conference and paper presentation activity.",
    "Research interests include nanomaterials, spectroscopy, and condensed matter physics.",
    "Supports doctoral research guidance as per VTU norms.",
  ],

  supervisors: [
    ["Dr. Mallikarjun K. Patil", "Assistant Professor", "f-mallikarjun-k-patil"],
    ["Dr. Sameer. M. Galagali", "Associate Professor", "f-sameer-m-galagali"],
    ["Dr. M. S. Sannaikar", "Assistant Professor", "f-m-s-sannaikar"],
  ],

  researchScholars: [
    ["Mr. Siddanguoda Tikkalaki", "Research Scholar", null, false],
    ["Mrs. Rajarajeshwari Kulkarni", "Research Scholar", null, false],
  ],
};

const PhysicsResearchCentre = () => <ProgrammeDetail programme={programme} />;

export default PhysicsResearchCentre;
